import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IBrand } from '../../../components/models/models'
import { IBrandNoticeRequest } from '../models/models'

export class UpdateBrandNoticeApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/brand/updateBrandNotice',
      requesterInfo,
    })
  }

  public async updateBrand(request: IBrandNoticeRequest): Promise<any> {
    return await this.postAsync<any>(request)
  }
}
